import AUTH from '../config/config-auth';

export const doLogin = ({ username, password }) => {
  return AUTH.post('', { username, password })
    .then(response => response.data)
    .catch(err => { throw err; });
};


// WEBPACK FOOTER //
// ./src/api/login-service.js